import React from 'react';
import { DismissOption, PromptType } from '../constants/parameters';
import useAccountSecurityPromptContext from '../hooks/useAccountSecurityPromptContext';
import { AccountSecurityPromptActionType } from '../store/action';
import ModalState from '../store/modalState';
import { dismissTemporary, startDismissForever } from './commonHandlers';

/**
 * The banner component for both prompt types.
 */
const BannerAccountSecurity: React.FC = () => {
  const {
    state: { promptType, dismissOption, resources },
    dispatch
  } = useAccountSecurityPromptContext();

  /*
   * Event Handlers
   */

  const openModalForPromptType = () => {
    if (promptType === PromptType.ADD_EMAIL) {
      dispatch({
        type: AccountSecurityPromptActionType.SET_MODAL_STATE,
        modalState: ModalState.ADD_EMAIL_FORM
      });
    } else {
      dispatch({
        type: AccountSecurityPromptActionType.SET_MODAL_STATE,
        modalState: ModalState.CHANGE_PASSWORD_INTRO
      });
    }
  };

  /*
   * Component Markup
   */

  return (
    <div className='alert alert-warning banner'>
      <div className='banner-description'>
        {resources.Description.UnusualActivity}{' '}
        {promptType === PromptType.ADD_EMAIL
          ? resources.Description.AddYourEmail
          : resources.Description.ChangeYourPassword}
      </div>
      <div className='banner-buttons'>
        {dismissOption === DismissOption.TEMPORARY_OR_FOREVER && (
          <span className='dark-theme banner-button'>
            <button
              type='button'
              className='btn-secondary-md'
              aria-label={resources.Action.DismissForever}
              onClick={startDismissForever(dispatch, promptType)}>
              {resources.Action.DismissForever}
            </button>
          </span>
        )}
        <span className='dark-theme banner-button banner-button-last'>
          <button
            type='button'
            className='btn-cta-md'
            aria-label={resources.Action.SecureAccount}
            onClick={openModalForPromptType}>
            {resources.Action.SecureAccount}
          </button>
        </span>
        <button
          type='button'
          className='close banner-close'
          aria-label={resources.Action.RemindMeLater}
          onClick={dismissTemporary(dispatch)}>
          <span className='icon-close-white' />
        </button>
      </div>
    </div>
  );
};

export default BannerAccountSecurity;
